<template>
  <div class="list">
    <transition name="fade" mode="out-in">
      <div v-if="show">
        <div class="post_list columns is-multiline " v-if="posts && posts.length" key="list">
          <!-- loop start -->
          <article class="column is-one-fifth" v-for="(post, key) of posts" v-bind:key="key">
            <router-link :to="{ name : 'Thread', params : { num : post.thread, page : page }}">
              <div class="card " style="height:100%">
                <div class="card-content">
                  <div class="media">
                    <div class="media-left">
                      <figure class="image is-64x64">
                        <img :src="['/bbs/img/' + post.icon + '.gif']" alt="" v-if="post.icon">
                      </figure>
                    </div>
                    <div class="media-content">
                      <p class="title is-6">{{post.name}}</p>
                    </div>
                  </div>
                  <h3 class="title is-5 thread-title" v-if="post.subj !== ''">{{post.subj}}</h3>
                  <h3 class="title is-5" v-else><router-link :to="{ name : 'Thread', params : { num : post.thread }}">no title</router-link></h3>
                  <div class="date">{{post.date | moment}}</div>
                  <!-- in v-html filter -->
                  <div class="comment" v-html="$options.filters.ellipsis(post.comment, 150)"></div>
                  <ul class="spec">
                    <li class="tag is-light">threadNo.{{post.thread}}</li>
                    <li class="res tag is-dark" v-if="post.res">{{post.res.length}}</li>
                    <li class="res tag is-light" v-else>0</li>
                  </ul>
                </div>
              </div>
            </router-link>
          </article>
          <!-- loop end -->
        </div>
        <div v-else-if="errors && errors.length">{{ errors[0].message }}</div>
        <div v-else>no thread <span class="button" @click="page_latest()">reset</span></div>
      </div>
    </transition>
    <ul v-if="posts && posts.length" class="columns is-centered pagenav">
      <li v-if="this.page !== 0" class="column is-one-third">
        <a class="button" :href="['./page/' + (this.page - 10)]" @click="page_prev">prev</a>
        </li>
      <li class="column is-one-third">
        <a class="button" :href="['./page/' + (this.page + 10)]" @click="page_next">next</a>
      </li>
    </ul>
    <b-loading :is-full-page="isFullPage" :active.sync="isLoading" :canCancel="true"></b-loading>
  </div>
</template>

<script>
export default {
  name: 'index',
  props: [ 'url', 'cate' ],
  title: 'Zion Board',
  data () {
    return {
      // url: 'http://192.168.0.16:8882/',
      // url: this.url2,
      isLoading: false,
      isFullPage: false,
      posts: [],
      media: [],
      errors: [],
      page: 0,
      show: false
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    ellipsis: function (str, size, suffix) {
      if (!str) str = '';
      if (!size) size = 32;
      if (!suffix) suffix = '...';
      var b = 0;
      for (var i = 0;  i < str.length; i++) {
          b += str.charCodeAt(i) <= 255 ? 1 : 2;
          if (b > size) {
              return str.substr(0, i) + suffix;
          }
      }
      return str;
    }
  },
  methods: {
    test_axios: function () {
      // console.log(__dirname,require("path").resolve("./"));
      this.openLoading()
      this.$http.get('/bbs/api/api.php?p='+this.page, {
        // params: {
        //   ID: this.hello
        // },
        // headers:{
        //   'X-Requested-With': null,
        //   'X-CSRF-TOKEN': null
        // },
        responseType: 'json',
        onDownloadProgress: function (progressEvent) {
          // transfer-encoding:chunked not set total size
          // console.log('aaa', progressEvent, progressEvent.loaded, progressEvent.total)
        }
      })
      .then(function (res) {
        this.isLoading = false
        this.show = true
        this.posts = res.data
      }.bind(this))
      .catch(function (err) {
        this.isLoading = false
        console.log(err.message)
        this.errors.push(err)
      }.bind(this))
    },
    openLoading() {
      const vm = this
      vm.isLoading = true
      this.show = false
      // setTimeout(() => {
      //     vm.isLoading = false
      // }, 10 * 1000)
    },
    page_prev(ev) {
      // console.log(ev);
      ev.preventDefault();
      this.page -= 10
      if(this.page <= 0){
        this.page = 0;
        this.test_axios()
        this.$router.push('/')
      } else {
        this.test_axios()
        this.$router.push('/page/' + this.page)
      }
      
    },
    page_next(ev) {
      ev.preventDefault();
      this.page += 10
      this.test_axios()
      //TODOTODO
      this.$router.push('/page/' + this.page)
    },
    page_latest(ev) {
      ev.preventDefault();
      this.page = 0
      // this.test_axios()
    }
  },
  created() {
    if(this.$route.params.page) this.page = parseInt(this.$route.params.page)
  },
  mounted: function () {
    this.test_axios()
  }
}
</script>

<style lang="scss" scoped>

.post_list{
  margin-bottom: 2rem;
}
.media{
  align-items: center;
  .media-content{
    overflow: visible;
  }
}
.thread-title{
  margin-bottom: 0.25rem;
}
.date{
  font-size: 0.8rem;
  color: #999999;
  margin-bottom: 1rem;
}
.comment{
  height: 200px;
  overflow: hidden;
  // font-size: 0.9rem;
}
.spec{
  position: absolute;
  right: 1.5rem;
  bottom: 1.5rem;
}
article{
  transition: 0.2s;
}
article:hover{
  z-index: 1;
  transform: scale(1.05);
}
figure{
  overflow: hidden;
  border-radius: 50%;
  img{
    filter: saturate(25%) brightness(1.05);
    transform: translateY(-10px);
  }
}
.pagenav{
  .button{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue